import { xml2js } from 'xml-js';

export const convertXmlToJson = (xmlstring: string): any => xml2js(xmlstring, {compact: true});
